<template>
<div class="select-col">
  <div>{{department_name}}</div>
  <div>
    <el-cascader v-model="department_id" :props="props" @change="onChange" ref="cascader"></el-cascader>
  </div>
</div>
</template>

<script>
import xhHelp from "../xhHelp";
import AppConfig from "../../../../../config/AppConfig";

export default {
  name: "SelectDepartmentCascader",
  props:{
    department_name:{
      type:String,
      default() {
        return "";
      }
    }
  },
  data(){
    return{
      props:{
        lazy: true,
        checkStrictly: true,
        lazyLoad (node, resolve) {
          const that=this;
          const { level,value } = node;

          xhHelp.get(AppConfig.flow_server+"/hr/department/getDepartmentList",{parent_id:value},ret=>{
            if(ret.data){
              const nodes = ret.data.map(item => ({
                id:item.id,
                value: item.id,
                label: item.department_name,
                name:item.ancestor_name,
                ancestor_id:item.ancestor_id,
                data:item,
                leaf: level >= 2
              }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            }
          })
        }
      },
      department_id:""
    }
  },
  model:{
    event:"eventDepartment",
    prop:"department_name"
  },
  watch:{
    department_name(n,o){
      // this.department_id="";
    }
  },
  methods:{
    onChange(e){
      const that=this;
      let data=(that.$refs.cascader.getCheckedNodes())[0].data
      that.$emit('eventDepartment',data.name)
      that.$emit('change',data)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-col{
  display: flex;
  flex-direction: column;
}
.select-row{
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/SelectDepartmentCascader.vue